import React, { Component } from 'react';
import Firebase from 'firebase';
import ClientData from './clientData.js';
import UpdatePhoto from './updatePhoto'
import { Router, browserHistory } from 'react-router'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, TabContent, TabPane, Nav, NavItem, NavLink, Progress } from 'reactstrap';
var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);


export default class cuenta extends React.Component {
    constructor() {
        super();
        this.state = {
            user: {},
            ready: false,
            showModal: false
        }
        this.updateData = this.updateData.bind(this);
        this.UpdatePhoto = this.UpdatePhoto.bind(this);
    }

    componentDidMount() {
        if (localStorage.uid) {
            var userRef = Firebase.database().ref('admin_users').child(localStorage.uid).once('value').then( snap => {
                this.setState({ user: snap.val(), ready: true })
            })
        } else {
            this.props.history.push("/#/login");
        }

    }

    updateData() {
        var count = 0;
        var usersRef = Firebase.database()
            .ref('admin_users')
            .child(localStorage.uid);
        usersRef.child("name").set(this.state.user.name).then((resp) => {
            usersRef.child("rut").set(this.state.user.rut).then((resp) => {
                this.refs.container.success(
                    "Datos actualizados correctamente",
                    "Información Básica", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
            });
        });
    }

    UpdatePhoto() {
        this.setState({ showModal: false });
        this.refs.container.success(
            "Foto de perfil actualizada correctamente",
            "Información Básica", {
                timeOut: 3000,
                extendedTimeOut: 10000
            });
    }


    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <ToastContainer ref="container"
                        style={{ top: "60px" }}
                        toastMessageFactory={ToastMessageFactory}
                        className="toast-top-right"
                    />
                    <ClientData client={this.state.user.client_id} />
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <strong>Datos personales</strong>
                            </div>
                            <div className="card-block">
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <div className="card-block" style={{padding : "20px"}}>
                                            <div className="form-group">
                                                <div className="card card-outline-primary">
                                                    <div className="card-block text-center">
                                                        <img src={this.state.user.photo ? this.state.user.photo : '/public/img/avatar.png'} className="img-avatar" width="200" />
                                                        <br />
                                                        <br />
                                                        <button type="button" className="btn btn-success" onClick={() => { this.setState({ showModal: true }) }} >Actualizar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card-block ">
                                            <div className="form-group row">
                                                <div className="input-group">
                                                    <span className="input-group-addon" style={{ width: "80px", backgroundColor: "#4fbd74", color: "#ffffff" }}>Email:</span>
                                                    <input type="text" className="form-control" id="company" value={this.state.user.email} readOnly />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="input-group">
                                                    <span className="input-group-addon" style={{ width: "80px", backgroundColor: "#4fbd74", color: "#ffffff" }}>Nombre:</span>
                                                    <input type="text" className="form-control" id="company" value={this.state.user.name} onChange={(e) => { var Data = this.state.user; Data.name = e.target.value; this.setState({ user: Data }) }} />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="input-group">
                                                    <span className="input-group-addon" style={{ width: "80px", backgroundColor: "#4fbd74", color: "#ffffff" }}>RUT:</span>
                                                    <input type="text" className="form-control" id="company" value={this.state.user.rut} onChange={(e) => { var Data = this.state.user; Data.rut = e.target.value; this.setState({ user: Data }) }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col col-xs-6 text-right">
                        <button type="button" className="btn btn-success" onClick={() => this.updateData()} >Guardar</button>
                    </div>
                </div>
                <Modal isOpen={this.state.showModal} toggle={() => { this.setState({ showModal: false }) }} className="modal-dialog modal-lg">
                    <ModalHeader toggle={() => { this.setState({ showModal: false }) }}>
                        Actualizar foto de perfil
                    </ModalHeader>
                    <ModalBody>
                        <UpdatePhoto data={this.state.user} callBack={this.UpdatePhoto} />
                    </ModalBody>
                </Modal>
                <br />
                <br />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/account/cuenta.js